export default "__VITE_ASSET__00WPkNPF__"